var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropFillCc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M61.38,237.549H55.256a.417.417,0,0,0-.308.132.441.441,0,0,0,0,.625l3.062,3.111a.425.425,0,0,0,.615,0l3.062-3.111a.441.441,0,0,0,0-.625A.417.417,0,0,0,61.38,237.549Z",
    transform: "translate(-54.818 -237.549)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropFillCc);
export default __webpack_public_path__ + "static/media/drop_fill_cc.e56c7afd.svg";
export { ForwardRef as ReactComponent };